import Store from '@/Store'
import { NavigationGuard, NavigationGuardNext, Route } from 'vue-router';

export default function UserHasScopes(scopes: string[]): NavigationGuard {
  return (to: Route, from: Route, next: NavigationGuardNext) => {
    if (Store.state.user.isAdmin) {
      next()
      return
    }

    const userScopes = Store.state.user.scopes;

    for (const scope of scopes) {
      if (userScopes.indexOf(scope) === -1) {
        next({ name: 'home' })
        return
      }
    }

    next();
  }
}

export function hasScope(scope: string): boolean {
  if (Store.state.user.isAdmin) {
    return true
  }

  const userScopes = Store.state.user.scopes;
  return !!userScopes.find((userScope: string) => userScope === scope )
}
